import React, { useState, useEffect,useRef } from 'react';
import axios from 'axios';
import { useHistory } from "react-router-dom";

import MaterialTable from "material-table";
import Sidebar from '../../Template/Sidebar/Sidebar';
import Header from '../../Template/Header/Header';
import {baseUrl} from '../../../config';
import DatePicker from "react-datepicker";
import './consumption.css';
import moment from 'moment'
import CloseIcon from '@mui/icons-material/Close';
import "react-datepicker/dist/react-datepicker.css";


import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import Loader from 'react-loader-spinner';

import {clickColor,inArray} from './../../../library/util';

/****** Advanced Filter ***********/
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import AsyncSelect from 'react-select/async';
import makeAnimated from 'react-select/animated';
import AddIcon from '@mui/icons-material/Add';
import objAdvancedFilter from '../../../library/advancedFilterLibFn';
import axiosIntance from '../../../helper/axios';

const animatedComponents = makeAnimated();

const colourStyles = {
  menuList: styles => ({
      ...styles,
      background: 'white'
  }),
  option: (styles, {isFocused, isSelected}) => ({
      ...styles,
      background: isFocused
          ? 'lightblue'
          : isSelected
              ? '#2a7bc0'
              : undefined,
      zIndex: 1
  }),
  menu: base => ({
      ...base,
      zIndex: 100
  })
  }
  const style_advanced = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };



const AddIconClasses={ color: '#337ab7',fontSize:'30px',marginLeft:'128px',marginTop:"-15px",cursor: 'pointer' };

const styleCloseIcon={
  margin:'-27px'
}



function AffiliateByParentSKU() {
    const history = useHistory();
    const [selectedRow, setSelectedRow] = useState(null);
    const ReportTile='Affiliate Front-Ends by Parent SKU';
   // const [startDate, setStartDate] = useState(new Date(new Date().getFullYear(), new Date().getMonth(), 1));

    const [startDate, setStartDate] = useState(new Date(Date.now() - 864e5));
    const [endDate, setEndDate] = useState(new Date(Date.now() - 864e5).setHours(23,59,0,0));

    const [AFFID,setAFFID]=useState('');
    const [AFFIDArray,setAFFIDArray]=useState([]);
    const [selectedrowList,setSelectedRowList]=useState([]);



   /************* Advanced Filter ***********/
   const [group,setgroup]=useState('');

   const [groupP,setgroupP]=useState('');

   const [groupT,setgroupT]=useState('');

   const [open, setOpen] = React.useState(false);
   const handleOpen = () => setOpen(true);
   const handleClose = () => setOpen(false);

   const selectInputRef = useRef();
   const selectInputRefInputFilter=useRef();
   const [filterLabel,setFilterLabel]=useState([])
   const [filterValue,setFilterValue]=useState('')
   const [filterArray,setFilterArray]=useState([]);

   const [filterValueT,setFilterValueT]=useState('')
   const [filterArrayT,setFilterArrayT]=useState([]);

   const [filterValueP,setFilterValueP]=useState('')
   const [filterArrayP,setFilterArrayP]=useState([]);
   const [selectLabelHeader,setSelectLabelHeader]=useState([]);
   const [selectLabelHeaderP,setSelectLabelHeaderP]=useState([]);


 const loadFilterLabel=(inputValue)=>
 {
   let tempCategory=selectLabelHeader;
   return new Promise((resolve) => {
     resolve(tempCategory.filter((i) =>
           i.label.toLowerCase().includes(inputValue.toLowerCase())
      ))
   });
 }
 const loadFilterLabelP=(inputValue)=>
 {
   let tempCategory=selectLabelHeaderP;
   return new Promise((resolve) => {
     resolve(tempCategory.filter((i) =>
           i.label.toLowerCase().includes(inputValue.toLowerCase())
      ))
   });
 }

 const handleChangeFilterP=(e)=>{
   if(e.target.value!=undefined){
     setFilterValueP(e.target.value);
   }
 }

 const handleChangeFilterT=(e)=>{
   if(e.target.value!=undefined){
     setFilterValueT(e.target.value);
   }
 }


 const addFilterT=()=>{
   if(groupT!='' && filterValueT!=''){
     let tempObj={field:groupT,value:filterValueT};  
       filterArrayT.push(tempObj);
       setFilterArrayT(filterArrayT);
       setFilterValueT('')
   }
 }

 const addFilterP=()=>{
   if(groupP!='' && filterValueP!=''){
     let tempObj={field:groupP,value:filterValueP};  
       filterArrayP.push(tempObj);
       setFilterArrayP(filterArrayP);
       setFilterValueP('')
   }
 }

 const deleteAdvancedFilterPFn = (item,index) =>{
  const arr = filterArrayP.filter((item,j) => j!=index);
  console.log(arr)
  setFilterArrayP(arr);
 }

 const deleteAdvancedFilterTFn = (item,index) =>{
  const arr = filterArrayT.filter((item,j) => j!=index);
  console.log(arr)
  setFilterArrayT(arr);
 }
const handleChangeT=( target )=> {
 if(target!=undefined){
   setgroupT(target.value);
 }
}

const handleChangeP=( target )=> {
 if(target!=undefined){
   setgroupP(target.value);
 }
}



    
   
    const handleSignOut = () => {
        window.localStorage.setItem('isLogin',false);
        history.push('/');
      }
      checkUserTypeFn(history);

      function checkUserTypeFn(history){
        const userdata=JSON.parse(localStorage.getItem('userdata'));
        const usertype=userdata.type;
        console.log('in check usertype fn');
        console.log(usertype)
        if(usertype!='admin' && usertype!='superadmin' && usertype!='subadmin' && usertype!='user' && usertype!='owneradmin'){
          history.push('/');
       }
      }
      const setRowBackground = (selectedRow)=>{
        if(inArray(selectedRow.tableData.id,selectedrowList)==false){ 
        setSelectedRowList(oldArray => [...oldArray,selectedRow.tableData.id] );
        setSelectedRow(selectedRow.tableData.id)
        console.log(selectedrowList)
        }else{    
          setSelectedRow(500000)
          setSelectedRowList([])
        }
      }
   
    if(localStorage.getItem('isLogin')==="false" || localStorage.getItem('isLogin')==null){
      history.push('/');
    }
  
    const [reportData,setReportData]=useState([])
    const [loader,setLoader]=useState(false)
    
    const [message, setMessage] = useState('')
    const data = [['attribute', 'attribute2'], ['value1', 'value2']];
    const [successMsg,setSuccessMsg]=useState('')
    useEffect(() => {
      setSelectLabelHeader(objAdvancedFilter.getFilterColumns('transactions'))
      setSelectLabelHeaderP(objAdvancedFilter.getFilterColumns('products'))
      //fetchApi();
      return () => {
        console.log('un subscribe')
      }
  
  
  
    }, [])
    
    const ResetFilter = () => {
      setMessage('')
      setEndDate(new Date(Date.now()))
      setStartDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
    }
   
  const fetchApi = () =>{
    let filterStringP='';
    filterArrayP.forEach((i,j)=>{
      filterStringP+=`P.${i.field}=${i.value}*`
    })

    let filterStringT='';
    filterArrayT.forEach((i,j)=>{
      filterStringT+=`T.${i.field}=${i.value}*`
    })

   
    if(startDate==null){
      setMessage('Date must not be blank')
      return false;
    }else{
      setMessage('')
    }
    setLoader(true)
    let affidStr=AFFIDArray.join(',');
    console.log(affidStr)
    
    
axiosIntance.get(baseUrl+'/reports/salesperformance/affiliateBySKU?startdate='+moment(startDate).format('YYYY-MM-DD HH:mm:ss')+"&enddate="+moment(endDate).format('YYYY-MM-DD HH:mm:ss')+"&affid="+affidStr+"&filterStringP="+filterStringP+"&filterStringT="+filterStringT, {}).then(response => {

    
        if (response.data.result.length > 0) {
          response.data.result.forEach((i,j)=>{
            i.decline_percent=roundToTwo(i.decline_percent*100)+"%";
          });
          setReportData(response.data.result);
          setLoader(false)
        } else {
          setLoader(false)
          setReportData([]);
        }
  
      }).catch(error => {
        setLoader(false)
        setMessage('Something went wrong');
      });
  }

  const fetchApiDownload = () =>{
    let filterStringP='';
    filterArrayP.forEach((i,j)=>{
      filterStringP+=`P.${i.field}=${i.value}*`
    })

    let filterStringT='';
    filterArrayT.forEach((i,j)=>{
      filterStringT+=`T.${i.field}=${i.value}*`
    })

   
    let affidStr=AFFIDArray.join(',');
    console.log(affidStr)
    const token = window.localStorage.getItem('token');
      window.location.href=baseUrl+'/reports/salesperformance/affiliateBySKU/download?startdate='+moment(startDate).format('YYYY-MM-DD HH:mm:ss')+"&enddate="+moment(endDate).format('YYYY-MM-DD HH:mm:ss')+"&affid="+affidStr+"&filterStringP="+filterStringP+"&filterStringT="+filterStringT+"&token="+token;
    
  }

  const FilterSet=() =>{
    console.log('Filter resete');
    console.log(AFFID);
    if(AFFID!=''){
        if(inArrayForString(AFFID,AFFIDArray)==false){ 
        setAFFIDArray(oldArray => [...oldArray,AFFID] );
        setAFFID('');
        }
      } 
    }
   
  

    const deleteAFFIDFn = (item,index) =>{
        console.log(item);
        removeItemOnce(AFFIDArray,item);
        console.log(AFFIDArray);
    
        let temp = AFFIDArray.filter((category) => category !== item);
        console.log(temp);
        setAFFIDArray(temp);
      }
  
  
  function removeItemOnce(arr, value) {
    var index = arr.indexOf(value);
    if (index > -1) {
      arr.splice(index, 1);
    }
    return arr;
  }
   
   
    return (
  
      <div id="wrapper" className>
        <Sidebar />
        <Header handleSignOut={handleSignOut} />



  <div></div> 
  <div></div>
  <div></div> 
  <div></div>
     
      <div className='errorMsg'>{message}</div>
      <div className='successMsg viewScreen'>{successMsg}</div>
  
  
  
  
    
  
  
    <section id="content-wrapper">

    <div classname="advancedFilterSection">
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
     <Box sx={style_advanced}>


<label>Transaction Header</label>
<label className='filterValueStyle'>Filter Values</label> 
<div class="input-bar">

<div className="input-bar-item width100">

<AsyncSelect
ref={selectInputRef}
components={animatedComponents}
onChange={e => handleChangeT(e)} 
  cacheOptions
  defaultOptions
  maxMenuHeight={250} 
  className="widthSelectInput"
  classNamePrefix="select"
    styles={colourStyles}
  getOptionLabel={(e) => e.label}
  getOptionValue={(e) => e.value}
  loadOptions={loadFilterLabel}        
/>
</div>

<>

&nbsp;&nbsp;&nbsp;
<div className="input-bar-item width100">
  <input type='text'
     ref={selectInputRefInputFilter}
     className='width140x filterValue'
     placeholder="Value"
     onChange={e => handleChangeFilterT(e)} 
     />
  <AddIcon style={AddIconClasses} onClick={addFilterT}/>
</div>
</>

 
<div className="input-bar-item width100">
<div className="input-bar-item closeModel closeIconCommon"> 
<CloseIcon className='closeIcon' onClick={handleClose}/>
</div>
</div>

</div>

<label>Products Header</label>
<label className='filterValueStyle'>Filter Values</label> 
<div class="input-bar">

<div className="input-bar-item width100">

<AsyncSelect
ref={selectInputRef}
components={animatedComponents}
onChange={e => handleChangeP(e)} 
  cacheOptions
  defaultOptions
  maxMenuHeight={250} 
  className="widthSelectInput"
  classNamePrefix="select"
    styles={colourStyles}
  getOptionLabel={(e) => e.label}
  getOptionValue={(e) => e.value}
  loadOptions={loadFilterLabelP}        
/>
</div>

<>

&nbsp;&nbsp;&nbsp;
<div className="input-bar-item width100">
  <input type='text'
     ref={selectInputRefInputFilter}
     className='width140x filterValue'
     placeholder="Value"
     onChange={e => handleChangeFilterP(e)} 
     />
  <AddIcon style={AddIconClasses} onClick={addFilterP}/>
</div>
</>

 
{/* <div className="input-bar-item width100">
<div className="input-bar-item closeModel closeIconCommon"> 
<CloseIcon className='closeIcon' onClick={handleClose}/>
</div>
</div> */}

</div>

<div className="input-bar-item width100">
<div className="FilterSection">

    {filterArrayT.map((item, index) => (
      <>
        <span className='filterCategory' id={index}>
        <span className="filterSpan">{item.field} = {item.value}</span>
        <CloseIcon onClick={(event) => deleteAdvancedFilterTFn(item,index)} className='closeIcon'/>
        </span>
        <span className="whitespaceSpan">{ '            ' }</span>
        </>
    ))}

{filterArrayP.map((item, index) => (
      <>
        <span className='filterCategory' id={index}>
        <span className="filterSpan">{item.field} = {item.value}</span>
        <CloseIcon onClick={(event) => deleteAdvancedFilterPFn(item,index)} className='closeIcon'/>
        </span>
        <span className="whitespaceSpan">{ '            ' }</span>
        </>
    ))}
</div>

</div>




     </Box>
     </Modal>
</div>

    <label>Date for Report</label>
    <div class="input-bar">
    <div className="input-bar-item width100">
    
    <DatePicker
      dateFormat="yyyy-MM-dd HH:mm"
      selected={startDate}
      className='width140x'
      onChange={(date) => setStartDate(date)}
      placeholder='Start Date'

      showTimeSelect
      timeFormat="p"
      timeIntervals={15}
      />

    </div>
    
    &nbsp;&nbsp;&nbsp;
 
    <div className="input-bar-item width100">
    
    <DatePicker
      dateFormat="yyyy-MM-dd HH:mm" 
      selected={endDate}
      className='width140x'
      onChange={(date) => setEndDate(date)}
      placeholder='End Date'

      showTimeSelect
      timeFormat="p"
      timeIntervals={15}
      />
      
    </div>
    &nbsp;&nbsp;&nbsp;

    &nbsp;&nbsp;&nbsp;
 
    {/* <div className="input-bar-item">
    
    <input type='text'
     name='affid'
     value={AFFID}
     className='width50x'
     placeholder="AFFID"
     onChange={e => setAFFID(e.target.value)}

     showTimeSelect
      timeFormat="p"
      timeIntervals={15}
     />
      
    </div> */}

    {/* <div className="input-bar-item">
    <button type="button"  onClick={FilterSet} className="btn btn-primary">Filter</button>
   
    </div> */}
    <div className="input-bar-item">
    <button type="button"  onClick={handleOpen}  className="btn btn-primary">Advanced Filter</button>
   
    </div>
    <div class="input-bar-item">
    <button type="button"  onClick={fetchApi} className="btn btn-primary">Run Report</button>
   
    </div>
    <div class='input-bar-item'>
    <button type="button"  onClick={ResetFilter} className="btn btn-primary">Reset</button>
    </div>

    {/* <div className='downloadReportBtn'>
        {
          
          reportData.length>0 ? <button type="button"  onClick={fetchApiDownload} className="btn btn-primary">Download Report in Excel</button>:''
         
        }
       
      </div> */}

<div className='downloadReportBtn'>
        {
          
           <button type="button"  onClick={fetchApiDownload} className="btn btn-primary">Download Report in Excel</button>
         
        }
       
      </div>
  </div>

  {/* <div className="FilterSection">
  
  {AFFIDArray.map((item, index) => (
      <span className="FilterSection"> 
       <span className='filterCategory' id={index}><span className="filterSpan">AFFID = {item}{ }</span>
       <span  onClick={(event) => deleteAFFIDFn(item,index)}><CloseIcon className='closeIcon'/></span>
       </span>
       <span className="whitespaceSpan">{ '            ' }</span>
       </span>
      
    ))}




    
  </div> */}

  <div className="FilterSection">

    {filterArrayT.map((item, index) => (
      <>
        <span className='filterCategory' id={index}>
        <span className="filterSpan">{item.field} = {item.value}</span>
        <CloseIcon onClick={(event) => deleteAdvancedFilterTFn(item,index)} className='closeIcon'/>
        </span>
        <span className="whitespaceSpan">{ '            ' }</span>
        </>
    ))}

{filterArrayP.map((item, index) => (
      <>
        <span className='filterCategory' id={index}>
        <span className="filterSpan">{item.field} = {item.value}</span>
        <CloseIcon onClick={(event) => deleteAdvancedFilterPFn(item,index)} className='closeIcon'/>
        </span>
        <span className="whitespaceSpan">{ '            ' }</span>
        </>
    ))}
</div>

  {loader ?
  <div className='loaderDiv'>  
  <Loader type="ThreeDots" color="#2BAD60" height="100" width="100" /></div> : 
  
          <MaterialTable
          // onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
          onRowClick={((evt, selectedRow) => 
            setRowBackground(selectedRow)
            )}
            columns={[

               { title: "AFFID", field: "affid" },
              { title: "NAME", field: "name" },
              { title: "AM", field: "am" },
              { title: "TOTAL", field: "total" },

              { title: "FL", field: "FL" },
              { title: "FUELSAVE", field: "FUELSAVE" },
              { title: "USB", field: "USB" },
              { title: "CAMLITE", field: "CAMLITE" },
              { title: "MICE", field: "MICE" },
              { title: "POWERSAVE", field: "POWERSAVE" },
              { title: "BONE", field: "BONE" },
              { title: "WIFIB-2.4G", field: "WIFIB_2_4G" },
              { title: "WIFI-USB", field: "WIFI_USB" },
              { title: "HEAT-V2", field: "HEAT_V2" },
              { title: "HEATEUV2", field: "HEATEUV2" },
              { title: "PROPURE", field: "PROPURE" },
              { title: "GLOSKETCH", field: "GLOSKETCH" },
              { title: "CARSAFETY", field: "CARSAFETY" },
              { title: "CARTOYBLUE", field: "CARTOYBLUE" },
              { title: "CARTOYPINK", field: "CARTOYPINK" },
              { title: "POSPRO", field: "POSPRO" },
              { title: "AGPUR", field: "AGPUR" },
              { title: "BUGZ", field: "BUGZ" },
              { title: "BUGGWATCH", field: "BUGGWATCH" },
              { title: "KNEESLEEVE", field: "KNEESLEEVE" },
              { title: "HAIRCURLER", field: "HAIRCURLER" },
              { title: "LASERREMOVER", field: "LASERREMOVER" },
              { title: "PETBRUSH", field: "PETBRUSH" },
              { title: "DBFM", field: "DBFM" },
              { title: "SHAVE", field: "SHAVE" },
              { title: "LRGSPKR", field: "LRGSPKR" },
              { title: "NOBARK", field: "NOBARK" },
              { title: "OXIMETER", field: "OXIMETER" },
              

              { title: "FUNGUSLASER", field: "FUNGUSLASER" },
              { title: "PHOTOSTICK", field: "PHOTOSTICK" },
              { title: "EBLB", field: "EBLB" },
              { title: "NDP", field: "NDP" },
              { title: "CARVAC", field: "CARVAC" },
              { title: "NECK", field: "NECK" },
              { title: "SADL", field: "SADL" },
              { title: "EZBZ", field: "EZBZ" },
              { title: "SNORE", field: "SNORE" },
              { title: "PIK", field: "PIK" },
              { title: "TEETH", field: "TEETH" },
              // { title: "KIDZTEETH", field: "KIDZTEETH" },
              // { title: "MOUTH", field: "MOUTH" },
              { title: "VEGGIECLEAN", field: "VEGGIECLEAN" },
              { title: "PLANT", field: "PLANT" },
              { title: "SCREEN", field: "SCREEN" },
              { title: "WHITENOISE", field: "WHITENOISE" },
              { title: "POPPCHOPP", field: "POPPCHOPP" },
              { title: "BKBOARD", field: "BKBOARD" },
              { title: "GROUT", field: "GROUT" },
              { title: "SUNSET", field: "SUNSET" },
              { title: "BOOB", field: "BOOB" },
              { title: "NTGLS", field: "NTGLS" },
              { title: "TCGL", field: "TCGL" },
              { title: "COOLWRISTS", field: "COOLWRISTS" },
              { title: "BIKEDOCK", field: "BIKEDOCK" },
              { title: "TEAMASK", field: "TEAMASK" },
              { title: "IPLPROV2", field: "IPLPROV2" },
              { title: "BLKSMARTWATCH", field: "BLKSMARTWATCH" },
              { title: "BLKFITNESSWATCH", field: "BLKFITNESSWATCH" },


              // { title: "AIR", field: "AIR" },
              // { title: "AIR-L", field: "AIR_L" },
              // { title: "DIFF-W", field: "DIFF_W" },
              // { title: "DIFF-B", field: "DIFF_B" },
              // { title: "DIFF-OIL", field: "DIFF_OIL" },
              
              // { title: "BOOB-SM", field: "BOOB_SM" },
              // { title: "BOOB-XL", field: "BOOB_XL" },
              // { title: "NTGLS", field: "NTGLS" },
              // { title: "GLASJUIC", field: "GLASJUIC" },
              
              
             
              

             
             
             
              

              
            
              // { title: "TEETH", field: "TEETH" },
              // { title: "KIDZTEETH", field: "KIDZTEETH" },
              // { title: "BOOB", field: "BOOB" },
              // { title: "NECK", field: "NECK" },
           
              // { title: "PIK", field: "PIK" },
              // { title: "NTGLS", field: "NTGLS" },
              // { title: "SADL", field: "SADL" },
              
             
              // { title: "SCREEN", field: "SCREEN" },
              
              // { title: "TCGL", field: "TCGL" },
            


              // { title: "BGCB", field: "BGCB" }, //
 

              // { title: "AIR", field: "AIR" },
              // { title: "BKBOARD", field: "BKBOARD" },
              // { title: "CARVAC", field: "CARVAC" },
              
              // { title: "SNORE", field: "SNORE" },
              // { title: "POPPCHOPP", field: "POPPCHOPP" },
              
              
             
              // { title: "EZBZ", field: "EZBZ" },
              

             
             
            ]}
            data={
                reportData
            }
            
             title={ReportTile}
            
            options={{
                actionsColumnIndex: -1,
                addRowPosition: "first",
                pageSize:10,
                loadingType: 'linear',
                paging: false,
                exportButton: true,
                maxBodyHeight: '500px',
                headerStyle: { position: 'sticky', top: 0,fontSize:'17px',fontWeight:'bold' },
                rowStyle: rowData => ({
                  backgroundColor: (selectedRow === rowData.tableData.id) ? clickColor : ''
                })

             
                
              }}
              
          />
        }
        </section>
       
      </div>

    )
}

function inArrayForString(needle, haystack) {
  var length = haystack.length;
  for (var i = 0; i < length; i++) {
  if (haystack[i].toLowerCase() == needle.toLowerCase())
   return true;
  }
  return false;
 }

function roundToTwo(num) {    
  return +(Math.round(num + "e+2")  + "e-2");
}

export default AffiliateByParentSKU
